import { YesObject } from '@yes.technology/react-toolkit'
import { useEffect, useRef } from 'react'
import { RelationFieldType } from '../types/object-view'

type UseRelationClassCardAutoEditEffectParams = {
  fieldType: RelationFieldType
  isEditing: boolean
  isFetching: boolean
  unsavedObjects: YesObject[]
  yesObjects: YesObject[]
  edit: () => void
}

const useRelationClassCardAutoEditEffect = ({
  fieldType,
  isEditing,
  isFetching,
  unsavedObjects,
  yesObjects,
  edit
}: UseRelationClassCardAutoEditEffectParams) => {
  const previousUnsavedUuidsRef = useRef<Set<string>>(new Set())

  useEffect(() => {
    const previousUnsavedUuids = previousUnsavedUuidsRef.current
    const currentUnsavedUuids = new Set(unsavedObjects.map((o) => o.uuid))
    previousUnsavedUuidsRef.current = currentUnsavedUuids

    if (fieldType !== 'card' || isEditing || isFetching) {
      return
    }

    const yesObjectUuids = new Set(yesObjects.map((o) => o.uuid))
    const hasNewlyAddedUnsaved = unsavedObjects.some(
      (unsavedObject) =>
        !previousUnsavedUuids.has(unsavedObject.uuid) &&
        !yesObjectUuids.has(unsavedObject.uuid)
    )

    if (hasNewlyAddedUnsaved) {
      edit()
    }
  }, [edit, isEditing, fieldType, isFetching, unsavedObjects, yesObjects])
}

export default useRelationClassCardAutoEditEffect
